/* global mymuesli */

(function () {

    /**
     * A model of a flavour flower.
     */
    class FlavourFlower extends mymuesli.entities.AbstractBase {

        /**
         * Initializes a new Flower model.
         *
         * @param plainObject The plain json (optional).
         */
        constructor (plainObject) {
            super({
                'sweet': 0,
                'creamy': 0,
                'crunchy': 0,
                'savoury': 0,
                'sour': 0
            }, plainObject);
        }

        /**
         * Updates the flower from a given list of ingredients.
         *
         * @param {mymuesli.entities.Ingredient[]} ingredients The recipe to calculate the flower for.
         */
        updateFromRecipe (ingredients) {
            const self = this;
            $.each(mymuesli.entities.FlavourFlower.PROPERTIES, function (_, flavourProperty) {
                let flavourValue = 0.0;

                /* Sum up all ingredient flavour values for the type. */
                $.each(ingredients, function (_, ingredient) {
                    if (ingredient.isBase) {
                        return;
                    }
                    flavourValue += ingredient.flavour[flavourProperty];
                });

                /* Calculate the medium value and normalize it. */
                flavourValue = flavourValue / Math.max(ingredients.length, 1);
                self[flavourProperty] = self.normalizeCalculatedFlavourValue(flavourValue);
            });
            this.notify();
        }

        /**
         * Returns the flavour flower profile as plain object.
         *
         * @return {{}} The flavour as plain object.
         */
        getFlavourFlowerAsPlainObject () {
            const self = this;
            const flavourProfile = {};
            $.each(FlavourFlower.PROPERTIES, function (_, flavourType) {
                flavourProfile[flavourType] = self[flavourType];
            });
            return flavourProfile;
        }

        /**
         * Convert the calculated value into a value in the range between 0 and 3.
         *
         * @param {int} flavourValue The calculated value.
         *
         * @return {int} The normalized value between 0 and 3.
         */
        normalizeCalculatedFlavourValue (flavourValue) {
            if (flavourValue < FlavourFlower.FlavourThresholdLevel_1) {
                return 0;
            }
            if (flavourValue < FlavourFlower.FlavourThresholdLevel_2) {
                return 1;
            }
            if (flavourValue < FlavourFlower.FlavourThresholdLevel_3) {
                return 2;
            }
            return 3;
        }

    }

    /**
     * The minimum value of the calculated flavour to be rated as level 1.
     *
     * @type {int}
     */
    FlavourFlower.FlavourThresholdLevel_1 = 0.50;

    /**
     * The minimum value of the calculated flavour to be rated as level 2.
     *
     * @type {int}
     */
    FlavourFlower.FlavourThresholdLevel_2 = 0.70;

    /**
     * The minimum value of the calculated flavour to be rated as level 3.
     *
     * @type {int}
     */
    FlavourFlower.FlavourThresholdLevel_3 = 1.50;

    /**
     * The property names of the flower.
     *
     * @type {[*]}
     */
    FlavourFlower.PROPERTIES = ['sweet', 'creamy', 'crunchy', 'savoury', 'sour'];

    mymuesli.entities.FlavourFlower = FlavourFlower;

}) ();
